<div class="container-fluid tp-box po-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap po-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">inventory</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<app-open-purchase-orders [vendor]="vendor_data" (orderloaded)="selectItemLookup($event)" (po_data)="updatePoData($event)"></app-open-purchase-orders>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="inventory"
				accent="danger"
				[value]="data ? data.length : null"
				[loading]="!data"
				[showView]="!!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
